import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./scss/index.scss";
import { TaxedMoney } from "@components/containers";
import { useCart } from "@sdk/react";
import { Loader } from "@temp/@next/components/atoms";
import { ErrorBoundary } from "@temp/components/ErrorBoundary";
import classNames from "classnames";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import ReactSVG from "react-svg";
import { RudderAnalytics } from "../../../app/analitics";
import { Button, Offline, OfflinePlaceholder, Online, Overlay } from "../..";
import { checkoutUrl } from "../../../app/routes";
import closeImg from "../../../images/x.svg";
import { CartPromoCode } from "./CartPromoCode";
import { CartUpsale } from "./CartUpsale";
import Empty from "./Empty";
import ProductList from "./ProductList"; // import cartImg from "../../../images/cart.svg";

var Cart = function Cart(_ref) {
  var overlay = _ref.overlay;
  // const { data: user } = useUserDetails();
  // const { checkout } = useCheckout();
  var intl = useIntl();

  var _useCart = useCart(),
      items = _useCart.items,
      removeItem = _useCart.removeItem,
      subtotalPrice = _useCart.subtotalPrice,
      discount = _useCart.discount,
      totalPrice = _useCart.totalPrice;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      promoCodeLoading = _useState2[0],
      setPromoCodeLoading = _useState2[1]; // const shippingTaxedPrice =
  //   checkout?.shippingMethod?.id && shippingPrice
  //     ? {
  //         gross: shippingPrice,
  //         net: shippingPrice,
  //       }
  //     : null;


  var promoTaxedPrice = discount && {
    gross: discount,
    net: discount
  };
  var count = (items === null || items === void 0 ? void 0 : items.reduce(function (prevVal, currVal) {
    return prevVal + currVal.quantity;
  }, 0)) || 0;

  var removeProductItem = function removeProductItem(productId, variantId, productAttributes) {
    var _item$variant, _item$variant$product;

    removeItem(variantId, productAttributes);
    var item = items === null || items === void 0 ? void 0 : items.find(function (o) {
      return o.variant.id === variantId;
    }); // @ analytics
    // TagManager.dataLayer({
    //   dataLayer: {
    //     ecommerce: {
    //       remove: {
    //         products: [
    //           {
    //             id: productId,
    //             name: item.variant?.product?.name,
    //             variant: variantId,
    //           },
    //         ],
    //       },
    //     },
    //     event: "removeFromCart",
    //   },
    // });

    RudderAnalytics.track("Product Removed", {
      name: (_item$variant = item.variant) === null || _item$variant === void 0 ? void 0 : (_item$variant$product = _item$variant.product) === null || _item$variant$product === void 0 ? void 0 : _item$variant$product.name,
      product_id: productId,
      variant: variantId
    });
  };

  return React.createElement(Overlay, {
    context: overlay
  }, React.createElement(Online, null, React.createElement("div", {
    className: "cart"
  }, React.createElement("div", {
    className: "overlay__header"
  }, React.createElement("div", {
    className: "overlay__header-text"
  }, React.createElement("span", {
    className: "overlay__header-text-title"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Shopping cart",
    "id": "components.OverlayManager.Cart.Cart.2719273225"
  }, "id", "components.OverlayManager.Cart.Cart.2719273225"))), React.createElement("span", {
    className: classNames("overlay__header-text-items", {
      "not-empty": !!count
    })
  }, count)), React.createElement(ReactSVG, {
    path: closeImg,
    onClick: overlay.hide,
    className: "overlay__header__close-icon"
  })), (items === null || items === void 0 ? void 0 : items.length) ? React.createElement(React.Fragment, null, React.createElement(ProductList, {
    lines: items,
    remove: removeProductItem
  }), React.createElement("div", {
    className: "cart__footer"
  }, React.createElement("div", {
    className: "cart__footer__price"
  }, React.createElement("span", {
    className: "cart__footer__price-name"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Subtotal:",
    "id": "components.OverlayManager.Cart.Cart.633139596"
  }, "id", "components.OverlayManager.Cart.Cart.633139596"))), React.createElement("span", null, React.createElement(TaxedMoney, {
    "data-cy": "cartPageSubtotalPrice",
    taxedMoney: subtotalPrice
  }))), React.createElement("div", {
    className: "cart__footer__price"
  }, React.createElement("span", {
    className: "cart__footer__price-name"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Delivery price:",
    "id": "components.OverlayManager.Cart.Cart.685872922"
  }, "id", "components.OverlayManager.Cart.Cart.685872922"))), React.createElement("span", null, intl.formatMessage(_defineProperty({
    defaultMessage: "Free",
    "id": "components.OverlayManager.Cart.Cart.2456755292"
  }, "id", "components.OverlayManager.Cart.Cart.2456755292")))), promoTaxedPrice && promoTaxedPrice.gross.amount !== 0 && React.createElement("div", {
    className: "cart__footer__price"
  }, React.createElement("span", {
    className: "cart__footer__price-name"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Promo code",
    "id": "components.OverlayManager.Cart.Cart.3343536271"
  }, "id", "components.OverlayManager.Cart.Cart.3343536271"))), React.createElement("span", null, promoCodeLoading ? React.createElement(Loader, {
    inline: true
  }) : React.createElement(TaxedMoney, {
    "data-cy": "cartPagePromoCodePrice",
    taxedMoney: promoTaxedPrice
  }))), React.createElement("div", {
    className: "cart__footer__price cart__footer__price-total"
  }, React.createElement("span", {
    className: "cart__footer__price-name"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Total price",
    "id": "components.OverlayManager.Cart.Cart.785948222"
  }, "id", "components.OverlayManager.Cart.Cart.785948222"))), React.createElement("span", null, promoCodeLoading ? React.createElement(Loader, {
    primary: true,
    inline: true
  }) : React.createElement(TaxedMoney, {
    "data-cy": "cartPageTotalPrice",
    taxedMoney: totalPrice
  }))), React.createElement("div", {
    className: "cart__footer__button"
  }, React.createElement(Link, {
    to: checkoutUrl
  }, React.createElement(Button, {
    className: "red"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Go To Checkout",
    "id": "components.OverlayManager.Cart.Cart.3953950992"
  }, "id", "components.OverlayManager.Cart.Cart.3953950992"))))), React.createElement(CartPromoCode, {
    loading: promoCodeLoading,
    setLoading: setPromoCodeLoading
  }), React.createElement(ErrorBoundary, null, React.createElement(CartUpsale, null)))) : React.createElement(Empty, {
    overlayHide: overlay.hide
  }))), React.createElement(Offline, null, React.createElement("div", {
    className: "cart"
  }, React.createElement(OfflinePlaceholder, null))));
};

export default Cart;